import { Student } from '~teacher/models/activities';

export const indexStudentByUserUuid = (students: Record<string, Student>) =>
  Object.values<Student>(students).reduce<Record<string, number>>(
    (accumulator, currentValue) => {
      const { id, userUuid } = currentValue;
      accumulator[userUuid] = id;
      return accumulator;
    },
    {}
  );

export const copyStudentEntities = (students: Record<string, Student>) =>
  ({ ...students } as Record<string, Student>);

export const normalizeStudent = (students: Record<string, Student>) => ({
  byStudentUserUuid: indexStudentByUserUuid(students),
  entities: copyStudentEntities(students),
});

export type NormalizedStudent = ReturnType<typeof normalizeStudent>;
